// Standard Library

// 3rd Party

// Local
import { LubooAuth } from '../general/luboo.auth.js';
import { registerDefaultElements } from './register-elements.js';

/**
 * Default Luboo Shell - Loaded on all pages
 * Provides core functionality like authentication
 */
class LubooDefaultShell {
  /**
   * Constructor for LubooDefaultShell.
   * @param {object} root0 - Arguments.
   * @param {Element} root0.$cont - Container element.
   */
  constructor({ $cont = document.body } = {}) {
    this.$cont = $cont;

    // Initialize auth module - available globally
    this.auth = new LubooAuth();

    // Initialize the module
    this.initialized = this._initModule();
  }

  /**
   * Get DOM element references
   */
  get _$Map() {
    return {
      $cont: this.$cont,
    };
  }

  /**
   * Async initialization of module
   * @returns {Promise<boolean>} - True when initialized
   */
  async _initModule() {
    try {
      // Register shared custom elements first so any HTML that renders
      // before auth completes (svg-icon, copy-right on auth pages) has
      // its tags defined. Issue #94 Phase 5.
      registerDefaultElements();

      // Wait for auth to initialize
      await this.auth.initialized;

      // Icon sets are now loaded directly in base.html
      // No need to initialize them here

      return true;
    } catch (error) {
      console.error('Default shell initialization error:', error);
      return false;
    }
  }
}

export { LubooDefaultShell };
